import {AuthService, AuthenticationError, TokenService, UserService, LocalizationService} from '@/services'
import router from '@/routes/router'

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  authenticationError: '',
  loggedUser: false
}

const getters = {
  loggedIn: (state) => {
    return state.accessToken ? true : false
  },

  authenticationError: (state) => {
    return state.authenticationError
  },

  authenticating: (state) => {
    return state.authenticating
  },

  loggedUser: (state) => {
    return state.loggedUser;
  }
}

const actions = {
  async init({commit, dispatch}) {
    await UserService.getAuthUser().then((response) => {
      commit('INIT_SUCCESS', response.data);

      if (response.data.language) {
        dispatch('Localization/setLocale', response.data.language, {root: true});
      }

    }).catch(() => {
      dispatch('logout');
    })
  },

  async initCheck({commit, dispatch}) {
    if (!state.loggedUser) {
      await dispatch('init');
    }
  },

  async login({commit, dispatch}, {email, password}) {
    commit('LOGIN_REQUEST');

    try {
      const token = await AuthService.login(email, password);
      commit('LOGIN_SUCCESS', token)

      await dispatch('init');
      await LocalizationService.init();

      // Redirect the user to the page he first tried to visit or to the home view
      router.push('/');

      return true
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit('LOGIN_ERROR', {errorCode: e.errorCode, errorMessage: e.message})
      }

      return false
    }
  },

  logout({commit}) {
    AuthService.logout()
    commit('LOGOUT_SUCCESS')
    router.push('/auth/login')
  }
}

const mutations = {
  INIT_SUCCESS(state, data) {
    state.loggedUser = data;
  },

  INIT_FAILED(state) {

  },

  LOGIN_REQUEST(state) {
    state.authenticating = true;
    state.authenticationError = ''
  },

  LOGIN_SUCCESS(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  LOGIN_ERROR(state, {errorCode, errorMessage}) {
    state.authenticating = false
    state.authenticationError = errorMessage
  },

  LOGOUT_SUCCESS(state) {
    state.accessToken = '';
    state.loggedUser = false;
  }

}

export const Auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}